
// export const myGetter = ( state ) => {
//  return state
// }

export const locationsList = state => state.locations
export const locationsSelectable = state => state.locationsSelectable
export const locationsPaginatedData = state => state.locationsPaginatedData
export const location = state => state.location
export const isLoadingLocation = state => state.isLoadingLocation
export const isCreatingLocation = state => state.isCreatingLocation
export const isUpdatingLocation = state => state.isUpdatingLocation
export const createdDataLocation = state => state.createdDataLocation
export const updatedDataLocation = state => state.updatedDataLocation
export const isDeletingLocation = state => state.isDeletingLocation
export const deletedDataLocation = state => state.deletedDataLocation
export const locationsProduct = state => state.locationsProduct
export const isLoadingLocationProduct = state => state.isLoadingLocationProduct